import React, {useEffect} from "react";
import {AEInput, CardBody, CardFooter, CardHeader} from "../../../../../_metronic/_partials/controls";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {AESVG} from "../../../../../_emywork/components/svg";
import {useIntl} from "react-intl";
import {useFormik} from "formik";
import {AEMetadata} from "../../../../../_emywork/AEPagination";
import {Dropdown} from "react-bootstrap";
import {DropdownCustomToggler} from "../../../../../_metronic/_partials/dropdowns";
import {AEAvatar} from "../../../../../_emywork/components/AEAvatar";
import {CONTEXT} from "../../../Users/helpers/ModuleHelpers";
import {AELink} from "../../../../../_emywork/components/AELink";
import {AEDuration} from "../../../../../_emywork/components/moment";
import moment from "moment";
import KTAppChat from "../../../../../_metronic/_assets/js/components/chat";
import {AEButton} from "../../../../../_emywork/components/buttons";
import * as actions from "../../../Groups/_redux/actions";
import {HTTP_CREATED} from "../../../../../_emywork/helpers/AxiosHelpers";
import {useModuleContext} from "../../ModuleContext";
import {actionTypes} from "../../_redux/slice";
import {EntityCard} from "../../../Users/componants/EntityCard";

export function Content({id, onUpdate}) {
  const dispatch = useDispatch();
  const {formatMessage} = useIntl();
  const {openDeleteDialog, openEditPage} = useModuleContext();
  const { authUser } = useSelector( ({auth}) => ({ authUser:auth.user }), shallowEqual );


  const { entity } = useSelector(
    state => {
      return state.groups[actionTypes.Details]
    }
    , shallowEqual )

  const refresh = () =>{
    dispatch(actions.fetchEntity(
      id,
      new AEMetadata({},{},{},
        ['id', 'name', 'user_id', 'created_by', 'members', 'members.*.skills', 'members.*.badge', 'members.*.is_saved',]),
      actionTypes.Details
    )).then(r=>{
      KTAppChat.init();
    });
  }

  useEffect(() => {
    if(id) {
      refresh()
    }
  }, [dispatch, id]);


  const limit = 5;

  return (
    <div className="card card-custom card-stretch">
      <CardHeader className="align-items-center align-items-between px-4 py-3">
        <div className="mr-auto font-weight-bolder font-size-lg">
          {entity.name}
        </div>
        {
          entity.user_id === authUser.id &&
          <div className="">
            <Dropdown>
              <Dropdown.Toggle as={DropdownCustomToggler} >
                <AESVG size={'lg'} path={'/General/Settings-1.svg'} />
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                <Dropdown.Item
                  onClick={() => {
                    openEditPage(id)
                  }}
                >
                  {formatMessage({id: 'EDIT'})}
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    openDeleteDialog(id)
                  }}
                >
                  {formatMessage({id: 'DELETE'})}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

          </div>
        }

      </CardHeader>
      <CardBody>
        <div className="scroll scroll-pull">
          <div className="messages">
            {
              entity.members.map(member=>(
                <EntityCard
                  key={member.id}
                  size={'md'}
                  entity={member}
                  className={'bg-light-primary'}
                />
              ))
            }
          </div>
        </div>
      </CardBody>
    </div>
  );


}
